module.exports = __webpack_public_path__ + "img/Logo_TecNM_Vertical_Blanco_Sin_Letras.b86cd4e6.svg";